var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OtherHeader',{attrs:{"img_header":_vm.header_image,"header":"แก้ไขคำถาม","link_back":"faqspage"}}),_c('Faqs_edit')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }